// src/components/panels/Statistics.jsx
import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '../ui/card';

const StatBox = ({ title, stats, unit }) => (
  <div className="space-y-2">
    <h3 className="text-sm font-medium text-gray-500">{title}</h3>
    <div className="grid grid-cols-2 gap-2 text-sm">
      <div className="space-y-1">
        <div className="flex justify-between">
          <span className="text-gray-500">Min:</span>
          <span className="font-medium">{stats.min.toFixed(1)} {unit}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-500">Max:</span>
          <span className="font-medium">{stats.max.toFixed(1)} {unit}</span>
        </div>
      </div>
      <div className="space-y-1">
        <div className="flex justify-between">
          <span className="text-gray-500">Avg:</span>
          <span className="font-medium">{stats.mean.toFixed(1)} {unit}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-500">Std Dev:</span>
          <span className="font-medium">{stats.stdDev.toFixed(1)} {unit}</span>
        </div>
      </div>
    </div>
  </div>
);

const Statistics = ({ processedData, units }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Statistics</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <StatBox
            title="Temperature"
            stats={processedData.temperature.stats}
            unit={units.temperature === 'C' ? '°C' : '°F'}
          />
          
          <StatBox
            title="Humidity"
            stats={processedData.humidity.stats}
            unit="%"
          />
          
          <StatBox
            title="Pressure"
            stats={processedData.pressure.stats}
            unit={units.pressure === 'hPa' ? 'hPa' : 'inHg'}
          />
          
          <StatBox
            title="Heat Index"
            stats={processedData.heatIndex.stats}
            unit={units.temperature === 'C' ? '°C' : '°F'}
          />
          
          <StatBox
            title="Dew Point"
            stats={processedData.dewPoint.stats}
            unit={units.temperature === 'C' ? '°C' : '°F'}
          />
          
          <StatBox
            title="Wet Bulb"
            stats={processedData.wetBulb.stats}
            unit={units.temperature === 'C' ? '°C' : '°F'}
          />
          
          <StatBox
            title="Absolute Humidity"
            stats={processedData.absoluteHumidity.stats}
            unit="g/m³"
          />
          
          <StatBox
            title="Air Density"
            stats={processedData.airDensity.stats}
            unit="kg/m³"
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default Statistics;